import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { SLACK_CONFIGURATIONS_QUERY_KEY } from 'hooks/queries/notifications/useGetSlackConfigurations';
import { SLACK_WORKSPACES_QUERY_KEY } from 'hooks/queries/notifications/useGetSlackWorkspaces';

export const useDeleteSlackWorkspaceMutation = (
  onSuccess?: () => void,
  onError?: () => void,
  showNotification = true
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => {
      return apiClient.notifications.deleteSlackWorkspace({ id });
    },
    onSuccess: () => {
      queryClient
        .invalidateQueries({
          predicate: (query) =>
            [
              SLACK_WORKSPACES_QUERY_KEY,
              SLACK_CONFIGURATIONS_QUERY_KEY,
            ].includes(query.queryKey[0] as string),
        })
        .then(() => {
          if (showNotification) {
            notify.success('Slack workspace deleted successfully');
          }
          onSuccess?.();
        });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
      onError?.();
    },
  });
};
